import { apiSlice } from "./apiSlice";

/**
 * Fulfil drawer on a sales order: what each step can act on right now, and the
 * step's action. Steps: allocate, pick-list, pick, pack, ship, invoice.
 */
const salesFulfilmentApi = apiSlice
  .enhanceEndpoints({ addTagTypes: ["SalesOrderFulfilment", "SalesOrderLines"] })
  .injectEndpoints({
    endpoints: builder => ({
      getFulfilmentStep: builder.query({
        query: ({ orderId, step }) => `/api/sale/v1/sale_order/${orderId}/fulfilment/${step}/`,
        providesTags: ["SalesOrderFulfilment"],
        keepUnusedDataFor: 0,
      }),
      runFulfilmentStep: builder.mutation({
        query: ({ orderId, step, body }) => ({
          url: `/api/sale/v1/sale_order/${orderId}/fulfilment/${step}/`,
          method: "POST",
          body,
        }),
        invalidatesTags: (result, error, { orderId }) => [
          "SalesOrderFulfilment",
          "SalesOrderLines",
          "order",
          { type: "orderDetail", id: orderId },
        ],
      }),
      previewFulfilmentBatch: builder.mutation({
        query: body => ({
          url: "/api/sale/v1/sale_order/fulfilment/preview/",
          method: "POST",
          body,
        }),
        invalidatesTags: ["SalesOrderFulfilment"],
      }),
      runFulfilmentBatch: builder.mutation({
        query: body => ({
          url: "/api/sale/v1/sale_order/fulfilment/run/",
          method: "POST",
          body,
        }),
        invalidatesTags: ["SalesOrderFulfilment", "SalesOrderLines", "order"],
      }),
      completeFulfilmentBatch: builder.mutation({
        query: body => ({
          url: "/api/sale/v1/sale_order/fulfilment/complete/",
          method: "POST",
          body,
        }),
        invalidatesTags: ["SalesOrderFulfilment", "SalesOrderLines", "order"],
      }),
    }),
  });

export const {
  useGetFulfilmentStepQuery,
  useRunFulfilmentStepMutation,
  usePreviewFulfilmentBatchMutation,
  useRunFulfilmentBatchMutation,
  useCompleteFulfilmentBatchMutation,
} = salesFulfilmentApi;
